class Timing {

	constructor(absolute, delta, beat0 = 0) {
		const relative = absolute - beat0;
		const beat = Math.floor(relative);
		let offBeat = 2 * (relative - beat);
		if (offBeat > 1) {
			offBeat -= 2;
		}
		this.absolute = absolute;
		this.relative = relative;
		this.beat = beat;
		this.offBeat = offBeat;
		this.delta = delta;
	}

	relativeTo(beat0) {
		return new Timing(this.absolute, this.delta, beat0);
	}

}

/* eslint-disable no-magic-numbers */
export default class Metronome {

	_hz = null;
	_total_beats = null;
	_timer = null;
	_offset = null;

	constructor({ tempo, total_beats, timer }) {
		this._hz = tempo / 60;
		this._total_beats = total_beats;
		this._timer = timer;
		this._offset = 0;
	}

	offsetBy(offset) {
		if (!isFinite(offset)) {
			throw new Error('Offset is not finite');
		}
		offset += this._offset;
		offset %= this._total_beats;
		while (offset < 0) {
			offset += this._total_beats;
		}
		this._offset = offset;
	}

	get() {
		return new Timing((this._timer.get() * this._hz + this._offset) % this._total_beats, this._timer.getDelta());
	}

}
